const days = ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
const MONTHS = {
  1: "янв",
  2: "фев",
  3: "март",
  4: "апр",
  5: "май",
  6: "июнь",
  7: "июль",
  8: "авг",
  9: "сен",
  10: "окт",
  11: "нояб",
  12: "дек",
};
export function getFormattedDateWithDay(date: string) {
  const [y, m, d] = date.split("-");
  // const day = new Date(date).getDate();
  const dayIndex = new Date(date).getDay();
  // console.log("🚀 ~ getFormattedDate ~ day:", day)
  //@ts-ignore
  return `${d} ${MONTHS[+m]} (${days[dayIndex]})`;
  // return `${d} ${MONTHS[+m]} ${day}`;
}

export function getFormattedDate(date: string) {
  const [y, m, d] = date.split("-");
  // const day = new Date(date).getDate();
  const dayIndex = new Date(date).getDay();
  // console.log("🚀 ~ getFormattedDate ~ day:", day)
  //@ts-ignore
  return `${d} ${MONTHS[+m]}`;
  // return `${d} ${MONTHS[+m]} ${day}`;
}


export function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); 
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); 
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}
